import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import HeaderStaticMap from './StaticMap/StaticMap.jsx';
import { Tablet, Desktop, Mobile } from '../Utils/MediaComponents/MediaComponents.tsx';

import { getStaticMaps } from '../../selectors/selectors.js';

export class Header extends React.Component {
  createContent(url) {
    return <HeaderStaticMap url={url} />;
  }

  render() {
    const staticMaps = this.props.staticMaps;
    const mapData = staticMaps && staticMaps.header ? staticMaps.header : {};

    return (
      <>
        <Desktop render={() => this.createContent(mapData.desk)} />
        <Tablet render={() => this.createContent(mapData.lap)} />
        <Mobile render={() => this.createContent(mapData.mobile)} />
      </>
    );
  }
}

Header.defaultProps = {
  staticMaps: null,
};

Header.propTypes = {
  staticMaps: PropTypes.object,
};

const mapStateToProps = (state) => ({
  staticMaps: getStaticMaps(state),
});

export default connect(mapStateToProps)(Header);
